// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.rentpayment.RentalManagerRentPaymentWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetListingAcceptsPaymentResponseDto, GetListingsEligibleForPaymentsResponseDto } from '../..';

export const RentalManagerRentPaymentWebApiHandler_getListingAcceptsPayment_Path =
  '/api/web/v1/users/rentPayment/getListingAcceptsPayment';

/**
 * get listing alias of a listing that accepts payment in the user's account
 */
export const RentalManagerRentPaymentWebApiHandler_getListingAcceptsPayment = (client = getClient()) => {
  return httpFrontEndRequest<never, never, GetListingAcceptsPaymentResponseDto>(
    {
      endpoint: RentalManagerRentPaymentWebApiHandler_getListingAcceptsPayment_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerRentPaymentWebApiHandler_getListingsEligibleForPayments_Path =
  '/api/web/v1/users/rentPayment/getListingsEligibleForPayments';

/**
 * get list of listings that are eligible for payments but aren't yet accepting them
 */
export const RentalManagerRentPaymentWebApiHandler_getListingsEligibleForPayments = (client = getClient()) => {
  return httpFrontEndRequest<never, never, GetListingsEligibleForPaymentsResponseDto>(
    {
      endpoint: RentalManagerRentPaymentWebApiHandler_getListingsEligibleForPayments_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
